import React from 'react';

export const ERROR_MESSAGE = (
  <p>
    Looks like we are having a problem, and are working to resolve the issue.
    Please try again in a few minutes.
  </p>
);

export const LOADING_MESSAGE = <p>Loading...</p>;
